import styled from 'styled-components';
import { GroupFieldItem } from '../GroupField/GroupField';

export const CheckboxFieldItemWrapper = styled(GroupFieldItem).attrs({
  as: 'label',
})`
  position: relative;
`;
export const CHECKBOX_SELECTOR = CheckboxFieldItemWrapper.toString();
